module.exports = __webpack_public_path__ + "static/media/Amumu.51d804c0.png";